import { render, staticRenderFns } from "./SizeLayoutView.vue?vue&type=template&id=bbdad9ca&scoped=true&"
import script from "./SizeLayoutView.vue?vue&type=script&lang=js&"
export * from "./SizeLayoutView.vue?vue&type=script&lang=js&"
import style0 from "./SizeLayoutView.vue?vue&type=style&index=0&id=bbdad9ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdad9ca",
  null
  
)

export default component.exports